import PropTypes from 'prop-types';
import React from 'react';

import SUMMARY_PACKAGE_RENDERERS from '~pricing/lib/summary-packages';
import { packageLabelToClassName } from '~pricing/lib/helpers';

import './package.scss';

const Package = ({
  details,
  skuCost,
  package: packageName,
  packageRenderers = SUMMARY_PACKAGE_RENDERERS
}) => {
  const packageClassName = packageLabelToClassName(details);
  const {
    features,
    headerRenderer: PackageHeader,
    footerRenderer: PackageFooter
  } = packageRenderers[packageName];

  // Filter out any hidden features. This is the opportunity for an
  // indvidual feature to remove itself from the feature list via
  // whatever logic
  const visibleFeatures = features.filter(feature => !feature.hidden);

  return (
    <article className="sm-package" key={packageName} data-testid="Package">
      <PackageHeader
        skuCosts={skuCost}
        details={details}
        packageName={packageName}
      />
      <section
        className={`sm-package__details sm-package--border-${packageClassName}`}
      >
        <ul className="sm-package__feature-list">
          {visibleFeatures.map(feature => {
            return (
              <li
                className="sm-package__feature"
                key={`${packageName}-feature-${feature.summaryLine}`}
              >
                {feature.summaryLine}
              </li>
            );
          })}
        </ul>
      </section>
      <footer className="sm-package__footer">
        <PackageFooter
          packageName={packageName}
          packageClassName={packageClassName}
        />
      </footer>
    </article>
  );
};

Package.defaultProps = {
  packageRenderers: SUMMARY_PACKAGE_RENDERERS
};

Package.propTypes = {
  details: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  skuCost: PropTypes.arrayOf(
    PropTypes.shape({
      skuType: PropTypes.string.isRequired,
      cost: PropTypes.number.isRequired
    })
  ).isRequired,
  package: PropTypes.string.isRequired,
  packageRenderers: PropTypes.objectOf(
    PropTypes.shape({
      headerRenderer: PropTypes.func.isRequired,
      footerRenderer: PropTypes.func.isRequired,
      features: PropTypes.array.isRequired
    })
  )
};

export default Package;
